import { useLabFiltering } from "@hub/services/use-lab-filtering";
import { LabCard } from "@hub/ui/cards/lab-card";
import React from "react";
import styles from "./search-results.module.css";
import { TemplateListComponent } from "@hub/ui/filtering/template-results/template-results.component";

interface LabResultsProps {
  enableCustomSampleWidget?: boolean;
  isTemplate?: boolean;
}

export const LabResults: React.FC<LabResultsProps> = ({
  isTemplate = false,
}) => {
  const { results } = useLabFiltering();

  if (!results) {
    return <div className={styles.results} />;
  }

  if (isTemplate) {
    return <TemplateListComponent topic={"templates"} items={results} />;
  }

  return (
    <div className={styles.results}>
      <div className={styles.results_list}>
        {results.length === 0 && (
          <div className={styles.noResults}>
            <span className={styles.noResults__title}>No results found.</span>
            <span className={styles.noResults__description}>
              Try checking filters or your search query and please try again!
            </span>
          </div>
        )}
        {results.length > 0 &&
          results.map((result, index) => {
            return (
              <React.Fragment key={result.path}>
                <LabCard
                  data={result}
                  testName="lab"
                  withTopBorder={index === 0}
                />
              </React.Fragment>
            );
          })}
      </div>
    </div>
  );
};
